import React, { createContext, useContext, useState } from 'react';
// Import generator helpers
// Usuwamy dane przykładowe – kontekst ma startować pusty i być wypełniany realnymi danymi

export interface EstimateData {
  titleInfo?: any;
  takeoffRows?: any[];
  tesRows?: any[];
  detailedRows?: any[];
  simplifiedRows?: any[];
  summary?: any;
}

interface Ctx {
  data: EstimateData;
  setSectionData: (section: keyof EstimateData, value: any) => void;
}

const EstimateDataContext = createContext<Ctx | undefined>(undefined);

export const useEstimateData = () => {
  const ctx = useContext(EstimateDataContext);
  if (!ctx) throw new Error('useEstimateData must be used within EstimateDataProvider');
  return ctx;
};

export const EstimateDataProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [data, setData] = useState<EstimateData>({
    takeoffRows: [],
    tesRows: [],
    detailedRows: [],
    simplifiedRows: [],
  });

  const setSectionData = (section: keyof EstimateData, value: any) => {
    setData(prev => ({ ...prev, [section]: value }));
  };

  return (
    <EstimateDataContext.Provider value={{ data, setSectionData }}>
      {children}
    </EstimateDataContext.Provider>
  );
}; 